import { IEntityNode, ISelectableNode } from '../types';
import { EntityMenuName, NodeWithName } from '../EntitySelectionPanelUI';
import { MenuItemIcon } from './NodeIcon';
import React, { forwardRef, useCallback } from 'react';
import { usePanelStateContext } from '../context';
import { areNodesEqual, isNodeEqualToEntity, isNoDetailsNode } from '../utils';
import useDelayedHover from '../useDelayedHover';
import { FavoriteStarIcon, IconWrapper, SvgIcon } from '../../../Icon';

interface IProps {
  indent: number;
  node: IEntityNode;
  onSelectNode: (node: IEntityNode) => void;
  selectedNode: ISelectableNode;
}

const EntityNode = forwardRef<HTMLDivElement, IProps>(
  ({ node, onSelectNode, selectedNode, indent }, ref) => {
    const { selectedEntities, disabledEntities, selectNodeHandler } =
      usePanelStateContext();
    const isEntitySelected = selectedEntities.some((entity) =>
      isNodeEqualToEntity(node, entity),
    );

    const selected = areNodesEqual(node, selectedNode);

    const isFavorite = 'isFavorite' in node ? node.isFavorite : false;
    const isEntityDisabled =
      !isEntitySelected &&
      (disabledEntities?.some((entity) => isNodeEqualToEntity(node, entity)) ??
        false);

    const selectHandler = useCallback(
      () => onSelectNode(node),
      [node, onSelectNode],
    );
    const { mouseLeaveHandler, mouseEnterHandler } =
      useDelayedHover(selectHandler);

    return (
      <NodeWithName
        onMouseEnter={
          !isEntityDisabled && !isNoDetailsNode(node)
            ? mouseEnterHandler
            : undefined
        }
        onMouseLeave={
          !isEntityDisabled && !isNoDetailsNode(node)
            ? mouseLeaveHandler
            : undefined
        }
        onClick={!isEntityDisabled ? () => selectNodeHandler(node) : undefined}
        $selected={selected}
        $disabled={isEntityDisabled}
        $indent={indent}
        ref={ref}
      >
        <MenuItemIcon node={node} />
        <EntityMenuName>{node.name}</EntityMenuName>
        {isEntitySelected && (
          <IconWrapper size={16}>
            <SvgIcon name="circle-check" width={12} height={12} />
          </IconWrapper>
        )}
        {isFavorite && <FavoriteStarIcon isActive={true} />}
      </NodeWithName>
    );
  },
);
export default EntityNode;
